<template>
  <div class="py-10 px-5 d-flex flex-column" style="height: 100%">
    <div
      v-for="(button, index) in buttons"
      :key="'button_' + index"
      class="mb-2"
    >
      <v-btn
        :color="button.color"
        :variant="!button.active ? 'outlined' : undefined"
        width="100%"
        @click="goTo(button)"
      >
        <span
          :class="[
            'text-white',
            { 'text-primary': !button.active },
            { 'text-accent3': button.primary && !button.active },
          ]"
          >{{ button.name }}</span
        >
      </v-btn>
    </div>
    <div style="flex-grow: 1">
      <v-btn
        v-if="!user().isLoggedIn"
        class="mr-1 mt-10"
        color="accent3 text-white"
        width="100%"
        @click="goToLogin()"
      >
        Login
        <v-icon class="ml-1" size="small"> fas fa-sign-in-alt</v-icon>
      </v-btn>
      <v-btn
        v-else
        class="mr-1 mt-10 bg-green pl-2"
        to="/accounts/profile"
        width="100%"
      >
        <v-icon class="mr-1" color="white"> fas fa-user-circle</v-icon>
        <span class="text-white ellipse-150">{{
          user().credentials.username
        }}</span>
      </v-btn>
    </div>
    <div>
      <router-link to="/">
        <v-img class="contain" height="70" src="/assets/fairsharing-logo.svg" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "NavigationDrawer",
  data() {
    return {
      buttons: [
        {
          name: "Standards",
          query: { fairsharingRegistry: "Standard" },
          path: "search",
          color: "accent3",
          active: false,
          primary: true,
        },
        {
          name: "Databases",
          query: { fairsharingRegistry: "Database" },
          path: "search",
          color: "accent3",
          active: false,
          primary: true,
        },
        {
          name: "Policies",
          query: { fairsharingRegistry: "Policy" },
          path: "search",
          color: "accent3",
          active: false,
          primary: true,
        },
        {
          name: "Collections",
          query: { fairsharingRegistry: "Collection" },
          path: "search",
          color: "primary",
          active: false,
          primary: false,
        },
        {
          name: "Organisations",
          path: "organisations",
          query: { fairsharingRegistry: undefined },
          color: "primary",
          active: false,
          primary: false,
        },
        {
          name: "Add content",
          path: "new",
          query: { fairsharingRegistry: undefined },
          color: "primary",
          active: false,
          primary: false,
        },
        {
          name: "Stats",
          path: "summary-statistics",
          query: { fairsharingRegistry: undefined },
          color: "primary",
          active: false,
          primary: false,
        },
      ],
    };
  },
  computed: {
    ...mapState("users", ["user"]),
    route() {
      return {
        path: this.$route.path,
        query: this.$route.query,
      };
    },
  },
  watch: {
    route: {
      deep: true,
      handler(val) {
        this.makeActiveButton(val);
      },
    },
  },
  mounted() {
    this.makeActiveButton(this.$route);
  },
  methods: {
    async goTo(button) {
      if (
        this.route.path.replace("/", "") !== button.path ||
        this.route.query["fairsharingRegistry"] !==
          button.query["fairsharingRegistry"]
      ) {
        this.buttons.forEach((button) => {
          button.active = false;
        });
        button.active = true;
        await this.$router.push({
          path: "/" + button.path,
          query: button.query,
        });
      }
    },
    async goToLogin() {
      if (this.$route.path !== "/accounts/login") {
        await this.$router.push({
          path: "/accounts/login",
          query: {
            goTo: this.$route.fullPath,
          },
        });
      }
    },
    makeActiveButton(val) {
      this.buttons.forEach((button) => {
        button.active =
          button.path === val.path.replace("/", "") &&
          button.query["fairsharingRegistry"] ===
            val.query["fairsharingRegistry"];
      });
    },
  },
};
</script>
